import axios from './axios'

export const getInsights = ({ params } = {}) => axios.get('insights', { params })
export const getInsight = null // get around lint issue
